export const fontsAlign = [
    "left",
    "center",
    "right",
    "justify"
]

export const fontsStyle = [
    "---",
    "bold",
    "italic",
]

export const fontsLine = [
    "---",
    "underline",
    "linethrough",
    "overline",
]

export const fonts = [
    "Arial",
    "Arial Black",
    "Brush Script MT",
    "Baskerville",
    "Bodoni MT",
    "Courier",
    "Calibri",
    "Courier New",
    "Comic Sans MS",
    "Calisto MT",
    "Cambria",
    "Candara",
    "Consolas",
    "Goudy Old Style",
    "Georgia",
    "Delicious",
    "Lucida Bright",
    "Franklin Gothic",
    "Trebuchet MS",
    "Tahoma",
    "Impact",
    "Helvetica",
    "Myriad Pro",
    "Verdana",
]